module.exports = __webpack_public_path__ + "media/images/design/icon_02-6c0f5efb29781d59909ef6be051078b7.svg";